export default (str: string): string => str.replace(/[^0-9]/g, '');
